var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 2.66653V1.99992C11.3334 1.63173 11.6319 1.33325 12.0001 1.33325C12.3683 1.33325 12.6668 1.63173 12.6668 1.99992V2.66653H13.3334C14.438 2.66653 15.3334 3.56196 15.3334 4.66653V6.66653V7.99986V11.3332C15.3334 13.5423 13.5425 15.3332 11.3334 15.3332H4.66672C2.45758 15.3332 0.666718 13.5423 0.666718 11.3332V7.99986V6.66653V4.66653C0.666718 3.56196 1.56215 2.66653 2.66672 2.66653H3.99999V1.99992C3.99999 1.63173 4.29847 1.33325 4.66666 1.33325C5.03485 1.33325 5.33333 1.63173 5.33333 1.99992V2.66653H11.3334ZM1.99999 7.99986V11.3331C1.99999 12.8059 3.1939 13.9998 4.66666 13.9998H11.3333C12.8061 13.9998 14 12.8059 14 11.3331V7.99986H1.99999ZM2.66666 3.9998H3.99999V3.99992C3.99999 4.36811 4.29847 4.66659 4.66666 4.66659C5.03485 4.66659 5.33333 4.36811 5.33333 3.99992V3.9998H11.3334V3.99992C11.3334 4.36811 11.6319 4.66659 12.0001 4.66659C12.3683 4.66659 12.6668 4.36811 12.6668 3.99992V3.9998H13.3333C13.7015 3.9998 14 4.29828 14 4.66647V6.66647H1.99999V4.66647C1.99999 4.29828 2.29847 3.9998 2.66666 3.9998Z",
    fill: "#060213"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.d6ab319cdf3a7d735177d1c90db51008.svg";
export { ForwardRef as ReactComponent };